export default __webpack_public_path__ + "static/media/triangle-empty.5be17aee.svg";